import { render } from "./TrainMenuLayout.vue?vue&type=template&id=4d43e62d"
import script from "./TrainMenuLayout.vue?vue&type=script&lang=js"
export * from "./TrainMenuLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__